import React, { useState, useEffect, useRef } from "react";
import { Helmet } from "react-helmet";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { DefaultButton } from "../../../../UI toolkit/Button/Button";
import { withTheme } from "styled-components";
import { connect } from "react-redux";
import { withRouter, Redirect, useLocation } from "react-router-dom";
import { Input } from "../../../../UI toolkit/Input/Input";
import times_solid from "../../../../assets/images/times-solid.svg";
import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertToRaw, convertFromRaw } from "draft-js";
import draftToHtml from "draftjs-to-html";
import { PreviewModal } from "./PreviewModal";
import { H5, P } from "../../../../UI toolkit/Text/Text";
import { Dropdown, Select } from "../../../../UI toolkit/Dropdown/Dropdown";
import caret_down from "../../../../assets/images/caret-down.svg";
import {
  getAnnouncementAction,
  postAnnouncementAction,
} from "../../../../store/Actions/Messages_AnnouncementsAction";

const NewAnnouncement = ({ user, token, theme, history }) => {
  const location = useLocation();

  const [openPreviewModal, setOpenPreviewModal] = useState(false);
  const [Images, setImages] = useState([]);

  const button = useRef();

  const contentMarkupDefault = {
    entityMap: {},
    blocks: [
      {
        key: "637gr",
        text: "Initialized from content state.",
        type: "unstyled",
        depth: 0,
        inlineStyleRanges: [],
        entityRanges: [],
        data: {},
      },
    ],
  };

  const content = convertFromRaw(contentMarkupDefault);
  const editorState = EditorState.createEmpty();

  const [state, setstate] = useState({
    title: null,
    ...content,
    ...editorState,
  });

  const onContentStateChange = (contentState) => {
    console.log(draftToHtml(contentState));
    setstate({ ...state, content: draftToHtml(contentState) });
  };

  const onEditorStateChange = (editorState) => {
    console.log(editorState);
    setstate({ ...state, editorState });
  };

  const uploadCallback = (file) => {
    let uploadedImages = Images;
    const imageObject = {
      file: file,
      localSrc: URL.createObjectURL(file),
    };
    uploadedImages.push(imageObject);
    setImages({ uploadedImages: uploadedImages });
    return new Promise((resolve, reject) => {
      resolve({ data: { link: imageObject.localSrc } });
    });
  };

  const config = {
    image: { uploadCallback },
  };

  if (user && token) {
    return (
      <>
        <Helmet>
          <meta charSet="utf-8" />
          <title>New Announcement</title>
          <link rel="canonical" href={location.pathname} />
        </Helmet>
        <div className="px-6 py-6 md:px-12 md:py-12">
          <div className="md:flex md:justify-between px-0.5">
            <H5 color={"#112E46"} fontWeight="700" className="pr-4">
              New Announcement
            </H5>
            <div className="mt-6 md:mt-0 flex justify-between">
              <div className="mr-3">
                <DefaultButton
                  small
                  p={"7px 16px"}
                  color={"#005674"}
                  bg={"#E4EDF0"}
                  placeholder="Set Fee"
                  type="number"
                  name="setfee"
                  value={2}
                  required
                >
                  Save draft
                </DefaultButton>
              </div>

              <div className="mx-3">
                <DefaultButton
                  small
                  p={"7px 16px"}
                  color={"#FFFFFF"}
                  bg={"#005674"}
                  placeholder="Set Fee"
                  type="number"
                  name="setfee"
                  value={2}
                  required
                  onClick={() => {
                    setOpenPreviewModal(true);
                  }}
                >
                  Preview & send
                </DefaultButton>
              </div>
              <div className="flex items-center">
                <div>
                  <img
                    src={times_solid}
                    alt="cancel"
                    style={{ height: "100%", width: "26px", cursor: "pointer" }}
                    onClick={() => {
                      history.push("/dashboard/announcements");
                    }}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="md:flex px-0.5 mt-11">
            <div className="md:w-3/12">
              <div className="mt-6">
                <div className="mb-1.5">
                  <P color={"#7A809B"} fontSize={"13px"} fontWeight={700}>
                    Subject
                  </P>
                </div>
                <Input
                  placeholder="Enter announcement subject"
                  type="text"
                  name="email"
                  required
                  onChange={(e) => {
                    setstate({ ...state, title: e.target.value });
                  }}
                  ref={button}
                />
              </div>
            </div>

            <div className="md:w-9/12" style={{ height: "100vh" }}>
              <div className="md:pl-12 pl-0 h-full">
                <div style={{ border: "1px solid #ccc", height: "100vh" }}>
                  <Editor
                    editorClassName={"report-editor"}
                    editorState={state.editorState}
                    onEditorStateChange={onEditorStateChange}
                    onContentStateChange={onContentStateChange}
                    toolbar={config}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <>
          {openPreviewModal ? (
            <PreviewModal
              Announcementstate={state}
              closeModal={() => {
                setOpenPreviewModal(false);
              }}
            />
          ) : null}
        </>
      </>
    );
  } else {
    return (
      <>
        <Redirect to="/" />
      </>
    );
  }
};

const mapStateToProps = (state) => {
  return {
    token: state.auth.token,
    user: state.auth.user,
    trades: state.transactions.trades,
    transfers: state.transactions.transfers,
    transactionsList: state.transactions.transactionsList,
    loading: state.transactions.loading,
    error: state.overview.error,
  };
};

// Link Actions to component
const mapDispatchToProps = (dispatch) => {
  return {
    getAnnouncementAction: () => dispatch(getAnnouncementAction()),
    postAnnouncementAction: (state, successCallback) =>
      dispatch(postAnnouncementAction(state, successCallback)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(withTheme(NewAnnouncement)));
